































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { toPascalCase } from '@/utils/utils';
import { GQL_invoice_invoice_emailLogs } from '@/queries/__generated__/invoice';

@Component
export default class InvoiceDeliveryLogs extends Vue {
  @Prop() private logs!: GQL_invoice_invoice_emailLogs[];
  private pc = toPascalCase;
}
